import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { updateNavigationState, updateRouterPrevPage } from './routerSlice'
import { useLocation } from 'react-router-dom'

export default function NavigationTracker() {
    const location = useLocation()
    const dispatch = useDispatch()

    /**
     * Update prev route
     */
    useEffect(() => {
        dispatch(updateNavigationState(location.pathname))
    }, [location])

    return null
}